import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const LoadingSpinner: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">{t('loadingSimpleHandshake')}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner; 